import { app } from "@/main";

export class RouteMeta {
  constructor() {}
  vue: Record<string, any> = app.config.globalProperties;
  hasContainer(): boolean {
    return this.vue.$route.meta.hasContainer !== false;
  }

  topbarCollapse(): boolean {
    return this.vue.$route.meta.topbarCollapse !== true;
  }

  isPageCourse(): boolean {
    return this.vue.$route.meta.pageCourse == true;
  }

  isPageCourseTraditional(): boolean {
    return this.vue.$route.meta.pageCourseTraditional == true;
  }

  isPageCourseInteractive(): boolean {
    return this.vue.$route.meta.isPageCourseInteractive == true;
  }

  disableFooter(): boolean {
    return this.vue.$route.meta.disableFooter !== true;
  }
}
